import { TPageName } from 'shared/common/types/applicationContext';

export async function importApp(pageName: TPageName) {
  switch (pageName) {
    case 'owner': {
      return (await import('shared/owner/containers/OwnerApp')).OwnerApp;
    }

    case 'sdam-prodam-ot-sobstvennika': {
      return (await import('shared/cold/containers/ColdApp')).ColdApp;
    }

    default:
      throw new Error('Unknown context.custom.pageName');
  }
}
